<template lang="pug">
  v-content
    LineLinkConfirmDialog(ref="LineLinkConfirmDialog" @save="doLink")
    LineLinkPrivacyPolicyAgreementDialog(ref="LineLinkPrivacyPolicyAgreementDialog" @agree="onClickPrivacyPolicyAgreement")
    v-container(fluid grid-list-md)
      v-layout
        v-flex(md12)
          v-card
            AlertBox(ref="errorMsg")
            v-card-text
              span {{ "連携する乗務員ID、電話番号、暗証番号を入力してください。" }}
            v-card-text
              v-flex(xs12 md3)
                v-text-field(box label="乗務員ID" v-model="driverId" :error-messages="getErrorMessages('driverId')")
              v-flex(xs12 md3)
                v-text-field(box label="電話番号" v-model="mobileNo" :error-messages="getErrorMessages('mobileNo')")
              v-flex(xs12 md3)
                v-text-field(box label="暗証番号" v-model="lineAuthNo" :error-messages="getErrorMessages('lineAuthNo')")
              v-flex(xs12 md3)
              v-layout(justify-center wrap row)
                v-btn(@click="doLink" :disabled="!!getTokenExpired()")
                  span アカウント連携を行う
</template>

<script>
import AlertBox from "@/components/common/AlertBox";
import EventDispatcher from "@/mixin/EventDispatcher";
import ExportHandler from "@/mixin/ExportHandler";
import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";
import LineLinkConfirmDialog from "@/components/line-link/LineLinkConfirmDialog.vue";
import ApiHandler from "../../../mixin/ApiHandler";
import LineLinkPrivacyPolicyAgreementDialog from "@/components/line-link/LineLinkPrivacyPolicyAgreementDialog.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

let axiosBase = new AxiosBase();
let $axios = Axios.http;

export default {
  components: {
    LineLinkPrivacyPolicyAgreementDialog,
    LineLinkConfirmDialog,
    AlertBox
  },
  mixins: [EventDispatcher, ExportHandler, ApiHandler],
  data: () => ({
    driverId: null,
    mobileNo: null,
    lineAuthNo: null,
    errorMessage: {
      mobileNo: null,
      lineAuthNo: null
    },
    privacyPolicyAgreementContext: null
  }),
  methods: {
    ...mapActions("line", {
      fetchLinkTokenExpired: "fetchLinkTokenExpired"
    }),
    ...mapMutations("line", {
      writeLinkToken: "writeLinkToken"
    }),
    ...mapGetters("line", {
      getLinkToken: "getLinkToken",
      getTokenExpired: "getTokenExpired"
    }),
    clearErrorMessage() {
      this.$refs.errorMsg.nonDisplayMessage();
      this.errors = {};
    },
    displayErrorMessage(message) {
      this.$refs.errorMsg.displayMessage(message);
    },

    checkLinkToken() {
      return this.fetchLinkTokenExpired().catch(errorMessage => {
        this.displayErrorMessage(errorMessage);
      });
    },

    onClickPrivacyPolicyAgreement(context) {
      this.privacyPolicyAgreementContext = context;
    },

    async doLink() {
      this.clearErrorMessage();
      // トークン有効期限のチェック
      if (!(await this.checkLinkToken())) return;

      const payload = {
        driverId: this.driverId,
        mobileNo: this.mobileNo,
        lineAuthNo: this.lineAuthNo,
        linkToken: this.getLinkToken(),
        privacyPolicyAgreementContext: this.privacyPolicyAgreementContext
      };

      $axios
        .post(axiosBase.getUrls().createNonce, payload)
        .then(res => {
          const nonce = res.data;
          window.location.href =
            "https://access.line.me/dialog/bot/accountLink?linkToken=" +
            this.getLinkToken() +
            "&nonce=" +
            nonce;
        })
        .catch(error => {
          if (error.response.data["fieldErrors"]) {
            this.setErrorMessages(error);
          } else {
            this.displayErrorMessage(error.response.data.message);
          }
          return Promise.reject(error);
        });
    }
  },
  created() {
    window.addEventListener(
      window.Common.Config.observer.onErrorResponseNetworkError,
      () => this.displayErrorMessage(window.Common.Messages.Common.Error.NetworkError),
      false
    );

    window.addEventListener(
      window.Common.Config.observer.onErrorResponse500,
      () => this.displayErrorMessage(window.Common.Messages.Common.Error.InternalServerError),
      false
    );
  },
  destroyed() {
    window.removeEventListener(window.Common.Config.observer.onErrorResponseNetworkError, () =>
      this.displayErrorMessage(window.Common.Messages.Common.Error.NetworkError)
    );
    window.removeEventListener(window.Common.Config.observer.onErrorResponse500, () =>
      this.displayErrorMessage(window.Common.Messages.Common.Error.NetworkError)
    );
  },
  mounted() {
    // GETパラメタのトークンをストアに保存
    this.writeLinkToken(this.$route.query.linkToken);

    // プライバシーポシリー同意が無い場合はダイアログ表示
    if (!this.privacyPolicyAgreementContext) {
      this.$refs.LineLinkPrivacyPolicyAgreementDialog.openDialog();
    }

    this.checkLinkToken();
  }
};
</script>
